import React from 'react'
import styles from './payment-form-loader.styl'
import { delayRender } from 'helpers/decorators'

const PaymentFormLoader = () => {
  return (
    <div className={[styles.wrapper, 'row'].join(' ')}>
      <div className="col-xs-12 col-md-5">
        <div className={styles.title} />
        <div className={styles.box} />
        <div className={styles.box} />
      </div>
      <div className="col-xs-12 col-md-7">
        <div className={styles.title} />
        <div className={styles.box} />
        <div className={styles.title} />
        <div className={styles.box} />
      </div>
    </div>
  )
}

PaymentFormLoader.displayName = 'PaymentFormLoader'

export default delayRender()(PaymentFormLoader)
